// extracted by mini-css-extract-plugin
export default {"errorImg":"WentWrong_errorImg__33GpD"};